import { render, staticRenderFns } from "./facebook_page.vue?vue&type=template&id=0a64a799"
import script from "./facebook_page.vue?vue&type=script&lang=js"
export * from "./facebook_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports